/* Nav scroll behavior — transparent to solid */
(function () {
    var nav = document.querySelector('.ed-nav');
    if (!nav) return;

    var threshold = 80;

    function onScroll() {
        if (window.scrollY > threshold) {
            nav.classList.add('nav-solid');
        } else {
            nav.classList.remove('nav-solid');
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
})();

/* Mobile menu burger toggle */
(function () {
    var nav = document.querySelector('.ed-nav');
    var burger = nav && nav.querySelector('.ed-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!nav.classList.contains('is-open')) {
            nav.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            nav.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Lightbox for gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video embeds */
(function () {
    var sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Dropdown nav when too many items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive tables */
(function () {
    var tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    tables.forEach(function (table) {
        var wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
